import { Injectable } from '@angular/core';
import {
	IAvailabilityApiResponse,
	IAvailabilityPeriod,
} from 'app/interfaces/availability.interface';
import { DateTime, Interval } from 'luxon';

@Injectable({
	providedIn: 'root',
})
export class CalendarAvailabilitiesService {
	isSlotAvailable(avaibilities: IAvailabilityPeriod[], luxonDate: DateTime) {
		const dayOfWeek = luxonDate.weekday;
		return avaibilities.some((avaibility) => {
			if (
				avaibility.dayOfWeek === dayOfWeek ||
				(dayOfWeek === 7 && avaibility.dayOfWeek === 0)
			) {
				const start = {
					hour: parseInt(avaibility.startTime.split(':')[0]),
					minute: parseInt(avaibility.startTime.split(':')[1]),
				};
				const end = {
					hour: parseInt(avaibility.endTime.split(':')[0]),
					minute: parseInt(avaibility.endTime.split(':')[1]),
				};
				const avaibilityPeriod = Interval.fromDateTimes(
					luxonDate.set({ hour: start.hour, minute: start.minute }),
					luxonDate.set({ hour: end.hour, minute: end.minute })
				);
				return avaibilityPeriod.contains(luxonDate);
			}
		});
	}

	getAvaibilitiesForPeriod(
		avaibilities: IAvailabilityApiResponse[],
		firstDate: DateTime,
		lastDate: DateTime
	) {
		const avaibilitiesForPeriod = [];
		const periodInterval = Interval.fromDateTimes(firstDate, lastDate);
		avaibilities.forEach((avaibility) => {
			const avaibilityInterval = Interval.fromDateTimes(
				DateTime.fromISO(avaibility.startDate),
				DateTime.fromISO(avaibility.endDate)
			);

			const avaibilityInCalendar =
				periodInterval.intersection(avaibilityInterval);

			if (avaibilityInCalendar) {
				avaibility.periods.forEach((period) => {
					avaibilityInCalendar
						.splitBy({
							day: 1,
						})
						.forEach((avaibilityDay) => {
							if (
								avaibilityDay.start.weekday === period.dayOfWeek ||
								(avaibilityDay.start.weekday === 7 && period.dayOfWeek === 0)
							) {
								avaibilitiesForPeriod.push(period);
							}
						});
				});
			}
		});
		return avaibilitiesForPeriod;
	}
}
